module.exports = __webpack_public_path__ + "braster-logo.png?2e5b2da5623d76a2686bcbd70c6c38b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/braster-logo.png
// module id = 930
// module chunks = 0